import getBlogItems from '@/api/blog/getBlogItems.endpoint';
import Blog from '@/pages/Blog/Blog';
import PageMetadata from '@/v2/domains/SEO/components/PageMetadata/PageMetadata';

export default function BlogPage({ pageProps }) {
  return (
    <>
      <PageMetadata title="Spanish Teaching Blog – Ideas & Resources for Educators | Rockalingua" />
      <Blog blogItems={pageProps.blogItems} />
    </>
  );
}

export const getStaticProps = async () => {
  const blogItems = await getBlogItems();
  return { props: { blogItems } };
};
